import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

interface SaveActionButtonProps {
  onClick: ButtonProps['onClick'];
  disabled?: boolean;
  isSaving?: boolean;
  text?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'contained' | 'outlined' | 'text';
  ariaLabel?: string;
  sx?: ButtonProps['sx'];
}

const SaveActionButton: React.FC<SaveActionButtonProps> = ({
  onClick,
  disabled = false,
  isSaving = false,
  text,
  size = 'small',
  variant = 'contained',
  ariaLabel = 'Save',
  sx,
}) => {
  const iconElement = isSaving ? <CircularProgress size={16} /> : <CheckIcon />;
  const isIconOnly = !text;

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      size={size}
      variant={variant}
      aria-label={ariaLabel}
      startIcon={isIconOnly ? undefined : iconElement}
      sx={{
        bgcolor: variant === 'contained' ? '#32CA1D' : undefined,
        color: variant === 'contained' ? '#000' : undefined,
        minWidth: isIconOnly ? 40 : undefined,
        width: isIconOnly ? 40 : undefined,
        px: isIconOnly ? 0 : 1.5,
        '&:hover': {
          bgcolor: variant === 'contained' ? '#28A518' : undefined,
        },
        '&.Mui-disabled': {
          bgcolor: variant === 'contained' ? 'grey.700' : undefined,
          color: variant === 'contained' ? 'grey.500' : undefined,
        },
        ...sx,
      }}
    >
      {isIconOnly ? iconElement : (isSaving ? 'Saving...' : text)}
    </Button>
  );
};

export default SaveActionButton;
